// extracted by css-extract-rspack-plugin
export default {"inlineEditingTextInput":"plVcI","selectLabel":"aR5Q4","cell":"tEp15","readonlyCell":"rYjZ1","errorCell":"GnIVf","updatingCell":"SP2nm","shine":"tKMjz"};